import React from 'react';
import type { Icon } from '@phosphor-icons/react';
import { WidgetGrid, type RasterElement } from './WidgetGrid';

/**
 * Gruppe im Widget-Raster. Bei „Alle“ steht eine Überschrift darüber
 * (README §4.4: 13 px/800, UPPERCASE, 0.05em, --ink3, mit Icon).
 */
export interface WidgetGroupProps {
  titel: string;
  icon: Icon;
  /** Überschrift zeigen (nur im Filter „Alle“). */
  mitUeberschrift?: boolean;
  /** Widgets mit Größe – das Raster packt sie lückenlos. */
  elemente: readonly RasterElement[];
}

export function WidgetGroup({ titel, icon: IconKomp, mitUeberschrift = true, elemente }: WidgetGroupProps) {
  return (
    <section className="flex flex-col" style={{ gap: 10 }} aria-label={titel}>
      {mitUeberschrift && <GruppenUeberschrift titel={titel} icon={IconKomp} />}
      <WidgetGrid elemente={elemente} />
    </section>
  );
}

export function GruppenUeberschrift({ titel, icon: IconKomp }: { titel: string; icon: Icon }) {
  return (
    <h3
      className="flex items-center m-0"
      style={{ gap: 8, padding: '6px 4px 0', fontSize: 13, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' }}
    >
      <IconKomp weight="bold" size={14} />
      {titel}
    </h3>
  );
}
